import React, { PureComponent } from 'react';
import combineStyles from '../../../utils/combineStyles';
import { SHIPMENT_STATUS } from './../../../constants/constants';
import TypographyStyles from '../../../styles/typography';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

const styles = theme => ({
  statusLabel: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    backgroundColor: 'red',
    borderRadius: '18px',
    fontFamily: theme.typography.font.main,
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '0.15px',
    lineHeight: '20px'
  },
  [SHIPMENT_STATUS.READY_TO_TENDER]: {
    backgroundColor: 'rgba(242,45,18,0.08)',
    color: '#F22D12'
  },
  [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: {
    backgroundColor: 'rgba(0,161,251,0.08)',
    color: '#00A1FB'
  },
  [SHIPMENT_STATUS.IN_TRANSIT]: {
    backgroundColor: 'rgba(254,176,11,0.12)',
    color: '#FEB00B'
  },
  [SHIPMENT_STATUS.DELIVERED]: {
    backgroundColor: 'rgba(0,195,150,0.08)',
    color: '#00C396'
  }
});

export class StatusLabel extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  };

  render() {
    const { label, classes, type } = this.props;
    const textColor = _get(
      classes,
      type,
      classes[SHIPMENT_STATUS.READY_TO_TENDER]
    );
    return (
      <span className={classnames(classes.statusLabel, textColor)}>
        {label}
      </span>
    );
  }
}

export default withStyles(combineStyles(styles, TypographyStyles))(StatusLabel);
